import React from 'react';
import { StyledButton } from './GhostButton.styled';
import { Loading } from './../../../../common/Icons/Loading';
import {
  BodySSemiBold,
  BodyMSemiBold,
} from './../../../../common/typography/typography';
import { IGhostButtonProps } from './../../../../common/interfaces/buttons';
import { buttonsVariantSize } from './../../../../common/styles/variants/variants';

function renderTitle(
  title: string,
  size: string,
  isDisabled: boolean,
  isLoading: boolean
) {
  const color = isDisabled || isLoading ? 'tertiary' : 'link';

  switch (size) {
    case 'l':
      return <BodyMSemiBold color={color}>{title}</BodyMSemiBold>;
    default:
      return <BodySSemiBold color={color}>{title}</BodySSemiBold>;
  }
}

export function GhostButton({
  title,
  onClick,
  isLoading = false,
  isDisabled = false,
  leftIcon,
  rightIcon,
  size = 's',
  ...rest
}: IGhostButtonProps) {
  if (isDisabled || isLoading) {
    return (
      <StyledButton
        onClick={onClick}
        isLoading={isLoading}
        padding={buttonsVariantSize[size].padding}
        borderRadius={buttonsVariantSize[size].borderRadius}
        {...rest}
      >
        {isLoading ? (
          <Loading />
        ) : (
          <>
            {leftIcon && leftIcon}
            {title && renderTitle(title, size, isDisabled, isLoading)}
            {rightIcon && rightIcon}
          </>
        )}
      </StyledButton>
    );
  }

  return (
    <StyledButton
      onClick={onClick}
      isLoading={isLoading}
      padding={buttonsVariantSize[size].padding}
      borderRadius={buttonsVariantSize[size].borderRadius}
      {...rest}
    >
      {isLoading ? (
        <Loading />
      ) : (
        <>
          {leftIcon && leftIcon}
          {title && renderTitle(title, size, isDisabled, isLoading)}
          {rightIcon && rightIcon}
        </>
      )}
    </StyledButton>
  );
}
